class SingleProduct extends HTMLLIElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // this.qty = parseInt(this.dataset.qty, 10);
    // this.stockQuantity = parseInt(
    //   new URL(window.location.href).searchParams.get("stock_quantity"),
    //   10,
    // );
    // this.title = this.dataset.title;
    // this.renderContent();
  }

  renderContent() {
    //   if (!isNaN(this.qty) && !isNaN(this.stockQuantity)) {
    //     if (this.qty < this.stockQuantity) {
    //       this.remove();
    //     }
    //   }
  }
}

// THE FIX IS HERE: Add the { extends: 'li' } option
customElements.define("single-product", SingleProduct, { extends: "li" });
